import Vue from 'vue';
import App from './App.vue';
import router from './router';
import vuetify from './plugins/vuetify';
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, { 
  siteKey: "6Ld2hXkhAAAAAEBGpFbrt8P_-axny6UD1ZZnht7B", 
});

new Vue({
  router,
  vuetify,
  render: (h) => h(App)
}).$mount('#app');
